export default "__VITE_ASSET__Dayu04dc__"